import React, { Component } from "react";

import HealthFolder from "./Components/Health/HealthFolder";

import "../../assets/css/main.css";

import EnterpriseActivityChart from "./Components/Charts/EnterpriseActivityChart";
import {HStack} from "@chakra-ui/react";
import LocalStorageService from "../../services/LocalStorageService";

import SummaryBatchPanel from "./Components/Grid/SummaryBatchPanel";

export default class DashboardPage extends Component {
    constructor(props) {
        super(props);

        this.localStorageService = new LocalStorageService();
        this.state = {}
    }

    // #Orgconfig removed for testing
    componentDidMount() {
        // var orgConfiguration = this.localStorageService.getOrgConfig(this.props.userSession.gcid);
        var orgConfiguration = {};
        orgConfiguration.inboundQueueEnabled = true;
        this.setState({ orgConfig: orgConfiguration });
    }

    render() {

        //var hasRoleRights = RoleManager.hasRoleRights(AppSecurityKey.VIEW_DASHBOARD, this.props.userSession.token);
        var hasRoleRights = true;
        return (

            (hasRoleRights) ?
                <div className="main">



                    <HStack marginBottom="20px" justifyContent={"space-between"}>
                        <HealthFolder
                            userSession={this.props.userSession}
                            healthInfo={this.props.healthInfo}
                            healthInfoTriggerKey={this.props.healthInfoTriggerKey}
                        />

                        <EnterpriseActivityChart
                            userSession={this.props.userSession}
                            showLegend={false}
                        />
                    </HStack>

                    <SummaryBatchPanel
                        userSession={this.props.userSession}
                        onErrorPageRequest={this.props.onErrorPageRequest}
                        onToastRequest={this.props.onToastRequest}
                        onMsgBoxRequest={this.props.onMsgBoxRequest}
                        onTriggerAutoRefresh={this.props.onTriggerAutoRefresh}
                        autoRefreshTriggerKey={this.props.autoRefreshTriggerKey}
                    />

                </div>
                : <span />
        )
    }

}